<script setup>
import { onMounted, ref } from 'vue';
import { $api } from '@/services';
import Edit from '@/views/tuitionSetting/Edit.vue';
import { useStore } from 'vuex';
import Loading from '@/components/common/Loading';

const store = useStore();
const sideOverShow = ref(false);
const listData = ref([]);
const isLoading = ref(false);
const editData = ref(null);

async function getTuitionNote() {
	try {
		isLoading.value = true;
		const res = await $api.org.getTuitionNote();
		if (res) {
			listData.value = res.data.data;
		}
		isLoading.value = false;
	} catch (e) {
		console.log(e);
	}
}
async function deleteTuition(id) {
	try {
		const res = await $api.org.deleteTuitionNote(id);
		if (res) {
			store.dispatch('setAlertMessage', {
				message: 'Xoá thông tin thanh toán thành công!',
				type: 'success',
			});
			getTuitionNote();
		}
	} catch (e) {
		console.log(e);
	}
}
function editSuccess() {
	sideOverShow.value = false;
	getTuitionNote();
}
function openEdit(value) {
	editData.value = value;
	sideOverShow.value = true;
}
onMounted(() => {
	getTuitionNote();
});
function openAdd() {
	editData.value = null;
	sideOverShow.value = true;
}
</script>
<template>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="close"
		></div>
		<Edit
			@close="sideOverShow = false"
			:editData="editData"
			@success="editSuccess"
		/>
	</div>
	<div class="flex items-center justify-end gap-1 cursor-pointer mb-6" @click="openAdd">
		<img src="@/assets/images/icons/yellow-plus.png" alt="add" />
		<div class="text-yellow-700 font-semibold text-sm">
			Thêm thông tin thanh toán
		</div>
	</div>
	<div v-if="isLoading">
		<Loading />
	</div>
	<div v-else-if="listData.length > 0">
		<div
			class="bg-white p-6 rounded-2xl shadow-sm text-gray-500 mb-6"
			v-for="item in listData"
			:key="item.id"
		>
			<div class="w-full flex items-center justify-between">
				<div class="text-lg font-semibold text-neutral-700">
					{{ item.name }}
				</div>
				<div class="flex items-center gap-4">
					<button
						class="button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
						type="button"
						@click="openEdit(item)"
					>
						<svg
							class="mr-1"
							fill="none"
							height="16"
							viewBox="0 0 16 16"
							width="16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								clip-rule="evenodd"
								d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z"
								fill="currentColor"
								fill-rule="evenodd"
							/>
						</svg>
						Chỉnh sửa
					</button>
					<button
						class="button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
						type="button"
						@click="deleteTuition(item.id)"
					>
						<svg
							class="mr-1"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
								fill="#E5A42B"
							/>
						</svg>
						Xoá
					</button>
				</div>
			</div>
			<div class="mt-4 flex items-stretch xl-down:flex-wrap">
				<div
					class="p-4 border xl-down:rounded-tl-lg border-neutral-200 w-full xl-down:w-1/2 md-down:rounded-t md-down:rounded-b-none"
				>
					<div>Ghi chú</div>
					<div
						class="text-base font-normal text-neutral-600 mt-2"
						v-if="item.content"
						v-html="item.content.replace(/\n/g, '<br />')"
					></div>
					<div
						class="text-base italic font-light text-neutral-400 mt-2"
						v-else
					>
						Chưa có ghi chú
					</div>
				</div>

				<div
					class="p-4 border rouder-r-lg xl-down:rounded-br-lg border-neutral-200 w-full xl-down:w-1/2 md-down:rounded-b md-down:rounded-t-none"
				>
					<div>Mã QR</div>
					<div
						class="text-base font-bold text-neutral-600 mt-2"
						v-if="item.asset_url"
					>
						<img
							style="width: 200px; height: 200px"
							:src="item.asset_url"
							alt=""
						/>
					</div>
					<div
						class="text-base italic font-light text-neutral-400 mt-2"
						v-else
					>
						Chưa có ảnh tải lên
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		v-else
		class="w-full h-full mt-20 flex items-center justify-center flex-col"
	>
		<img
			src="@/assets/images/illustrations/not_found.png"
			alt=""
			height="250"
			width="250"
		/>
		<div
			class="text-neutral-500 text-lg text-center"
			style="max-width: 700px"
		>
			Trung tâm chưa có thông tin thanh toán nào.
		</div>
	</div>
</template>
